import "../css/header.scss";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [moreOpen, setMoreOpen] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={toTop} aria-label="Sacuddin home">
          <img src="/brand-logo.svg" alt="Sacuddin" />
        </Link>

        <nav className="main-nav">
          <Link to="/shop" onClick={toTop}>
            Shop All
          </Link>
          <Link to="/about" onClick={toTop}>
            About
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact Us
          </Link>
          <div className="more-menu">
            <button
              type="button"
              className="more-toggle"
              aria-expanded={moreOpen}
              aria-controls="more-links"
              onClick={() => setMoreOpen((open) => !open)}
            >
              More
              <svg viewBox="0 0 12 8" aria-hidden="true">
                <path d="M1 1.5 6 6.5l5-5" />
              </svg>
            </button>
            {moreOpen && (
              <div className="more-dropdown" id="more-links">
                <Link to="/privacy" onClick={() => { setMoreOpen(false); toTop(); }}>
                  Privacy
                </Link>
                <Link to="/cookies" onClick={() => { setMoreOpen(false); toTop(); }}>
                  Cookies
                </Link>
                <Link to="/terms" onClick={() => { setMoreOpen(false); toTop(); }}>
                  Terms
                </Link>
                <Link to="/faqs" onClick={() => { setMoreOpen(false); toTop(); }}>
                  FAQs
                </Link>
                <Link to="/returns" onClick={() => { setMoreOpen(false); toTop(); }}>
                  Returns
                </Link>
                <Link to="/shipping" onClick={() => { setMoreOpen(false); toTop(); }}>
                  Shipping
                </Link>
              </div>
            )}
          </div>
        </nav>

        <div className="header-icons">
          <Link
            to="/cartpage"
            className="icon-btn cart-btn"
            aria-label="Shopping Cart"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </svg>
            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
